import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import TextField from "@mui/material/TextField";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";
import updChar from "../../_sig_api/updChar";
import {displayVerteidigungModNSC} from "../../_helper/displayVerteidigungModNSC";
import {s_char} from "../../_signals/s_char";

export default function CharSVNSC() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <TextField InputLabelProps={{shrink: true}}
                       onChange={e => updChar([{k:'sv',v: parseInt(e.target.value)}])}
                       style={{marginLeft: 8, maxWidth: 80}}
                       defaultValue={s_char.value.sv}
                       variant="standard" type="number" label="Soz Vert:" id="sv"
                       name="sv"/>
            {displayVerteidigungModNSC('sv')}
        </Item>
    </Grid>;
}